(ns frontend.view.not-found
  (:require [frontend.routing :as routing]
            [common.localization :as loc]
            [frontend.logging :as logging]
            [frontend.page-components.default-page-layout :as default-page-layout]))

(defn not-found-content []
  [:div
   {:class "h-[calc(100vh_-_52px)] overflow-auto"}
   [:div 
    {:class "px-4 py-8 lg:mx-auto lg:w-5xl flex flex-col gap-8 text-center"}
    [:span
     {:class "text-xl"}
     (loc/tr :not-found-header)]
    [:div
     (loc/tr :not-found-content)]]])

(defn not-found-view []
  [default-page-layout/view
   [not-found-content]])

(defmethod routing/render-view :not-found [_]
  [not-found-view])

(defmethod routing/render-view :default [args]
  (logging/error "NOT FOUND " args)
  [not-found-view])
